module.exports = __webpack_public_path__ + "static/btn.7cebb24d.png";